"use client";

import { PageCareerDetailSchema } from "@/sanity/pages/PageCareerDetailTemplate";

import Footer from "../global/partials/Footer";
import HeaderV2 from "../global/partials/HeaderV2";
import ApplicationProcessSection from "../pageComponents/careers/ApplicationProcessSection";
import BenefitsSection from "../pageComponents/careers/BenefitsSection";
import CareerHeroSection from "../pageComponents/careers/CareerHeroSection";
import TasksProfileSection from "../pageComponents/careers/TasksProfileSection";
import WhoWeAreSection from "../pageComponents/careers/WhoWeAreSection";
import FaqSection from "../pageComponents/global/sections/FaqSection";
import DesignScaleLock from "../global/DesignScaleLock";

export default function PageCareerDetailJSX({ data }: { data: PageCareerDetailSchema }) {
  const settings = data.careerSettings;

  const benefits = {
    ...settings,
    benefitsCTA: [data.benefitsCTAOverride, data.heroCTA, settings?.benefitsCTA].find(
      (button) => button?.cta,
    ),
    benefitsItems: data.benefitsItemsOverride?.length
      ? data.benefitsItemsOverride
      : settings?.benefitsItems,
  };

  const finalCta = {
    ...settings,
    finalCtaChip: data.finalCtaChip || settings?.finalCtaChip,
    finalCtaTitle: data.finalCtaTitle?.length ? data.finalCtaTitle : settings?.finalCtaTitle,
    finalCtaButton: data.finalCtaButton?.cta
      ? data.finalCtaButton
      : data.heroCTA?.cta
        ? { ...settings?.finalCtaButton, cta: data.heroCTA.cta }
        : settings?.finalCtaButton,
  };

  // Above 1920 the site's root font-size switches from the 1920 to the 2200
  // basis and every rem box shrinks 12.5% (6.99px at 1921). The careers comps are
  // drawn at 1920 and should keep their proportions on wide screens, so the page
  // is zoomed by 2200/1920 from the `hd` breakpoint (1921px): continuous at the
  // boundary (6.99px x 1.1458 = 8px), page-scoped, no :root override.
  return (
    <main className="flex flex-col items-center hd:[zoom:1.1458333]">
      <DesignScaleLock />
      {data?.settings?.header && (
        <HeaderV2
          data={data.settings.header}
          headerStyle="light"
          headerType="main"
          language={data.settings?.language}
        />
      )}

      <CareerHeroSection data={data} />
      <WhoWeAreSection data={settings} />
      <TasksProfileSection data={data} />
      <BenefitsSection data={benefits} />
      <ApplicationProcessSection
        data={settings}
        cta={data.processCTAOverride?.cta ? data.processCTAOverride : settings?.benefitsCTA}
      />
      {settings && (
        <FaqSection
          className="py-[8rem] lg:py-[15rem] max-lg:[&_button[data-state=open]]:pb-[1.35rem] max-lg:[&_svg]:h-[1.5rem] max-lg:[&_svg]:w-[1.5rem] [&>div]:gap-[4rem]"
          data={settings}
        />
      )}

      {data?.settings?.footer && <Footer data={data.settings?.footer} finalCta={finalCta} showTrustpilot={false} wideFinalCtaTitle language={data?.settings?.language} />}
    </main>
  );
}
